import { render, staticRenderFns } from "./ProductModelList.vue?vue&type=template&id=6a1f8112&scoped=true&"
import script from "./ProductModelList.vue?vue&type=script&lang=js&"
export * from "./ProductModelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f8112",
  null
  
)

export default component.exports